import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import Helper from "util/Helper";
import AuthenticationService from "../../../../../service/auth/AuthenticationService";

export class RefundDashboardUtils {
  constructor() {
    this.apiService = new APIService();
    this.helper = new Helper();
    this.authenticationService = new AuthenticationService();
  }
  fetchRefundsByFilter = (body, onResponse, onError) => {
    let url = APIConfig.refund.refundsByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  };
}

export default RefundDashboardUtils;
